<div class="charges-page content me-0 ms-0">
    <router-outlet></router-outlet>
</div>
